<template>
  <div class="text-sm">
    <p class="mt-6"><b>2025.01.04</b> - 9 новых мобов в Пещеры! Плюс исправления баланса и ИИ...</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        Готовьтесь встретить этих новых мобов в Пещеры:
        <ul>
          <li>- Эктоплазма</li>
          <li>- Огненный дрейк</li>
          <li>- Летающее желе</li>
          <li>- Призрак</li>
          <li>- Слизь</li>
          <li>- Лич</li>
          <li>- Фантазм</li>
          <li>- Странник Пустоты</li>
          <li>- Призрак смерти</li>
        </ul>
      </li>
      <li>
        Баланс
        <ul>
          <li>
            - Уменьшена длительность страхов
            <ul>
              <li class="pl-4">
                * Дорога в никуда:
                <code>1 + Уровень*(Об/100 + Вс/150)</code> -->
                <code>1 + Уровень*(Об/150 + Вс/200)</code>
              </li>
              <li class="pl-4">
                * Маска дьявола:
                <code>0.5 + Уровень*(Ма/250 + Об/350)</code> -->
                <code>0.5 + Уровень*(Ма/333 + Об/333)</code>
              </li>
            </ul>
          </li>
          <li>
            - Уменьшена длительность Насмешка:
            <code>1 + Уровень*(Вл/200 + Вс/250)</code> -->
            <code>1 + Уровень*(Вл/225 + Вс/275)</code>
          </li>
          <li>
            - Увеличена длительность призванных Дворфы/Эльфы/Феи:
            <code>40 + Уровень*2</code> --> <code>40 + Уровень*5</code>
          </li>
          <li>
            - Увеличена стоимость ОД нескольких способностей:
            <ul>
              <li class="pl-4">* Дорога в никуда: <code>15</code> --> <code>50</code></li>
              <li class="pl-4">
                * Призыв дворфа/Эльф/Фея: <code>10</code> -->
                <code>35</code>
              </li>
              <li class="pl-4">* Нервный срыв: <code>10</code> --> <code>35</code></li>
              <li class="pl-4">* Маска дьявола: <code>40</code> --> <code>50</code></li>
              <li class="pl-4">* Куклы вуду: <code>10</code> --> <code>35</code></li>
              <li class="pl-4">* Благословение: <code>10</code> --> <code>25</code></li>
            </ul>
          </li>
          <li>
            - ОДНА способность, однако, получила снижение стоимости ОД - Танец стоек:
            <code>70</code> --> <code>50</code>
          </li>
          <li>
            - Увеличена дальность Призыв опциона:
            <code>5</code> --> <code>9</code>
          </li>
          <li>- Уменьшен урон срабатывания оружия Огненный/Грозовой/Weepin/Ядовитый,</li>
          <li>
            - Скорректированы цены предметов в магазине (учитывают
            префиксы/суффиксы)
          </li>
          <li>- Увеличены бонусы характеристик для предметов типа Безделушка</li>
        </ul>
      </li>
      <li>
        ИИ
        <ul>
          <li>
            - Исправлен баг, заставлявший дальних юнитов использовать AoE атаки, когда одиночная цель
            лучше
          </li>
          <li>- Исправлены баги в ИИ движения, особенно для юнитов с Прыжок/Телепортация</li>
          <li>- Исправлен баг, заставлявший юнитов окуривать множество ближайших союзников</li>
          <li>- Танки больше не будут провоцировать испуганных врагов</li>
        </ul>
      </li>
      <li>Исправлена способность Наложение швов</li>
      <li>
        Исправлены несколько багов в расчётах урона, особенно для Шипастая броня. Также урон от яда и кровотечения теперь зависит от Affinities
      </li>
      <li>Пещеры: проигрывается звук оповещения при зачистке комнаты</li>
    </ul>
  </div>
</template>
